import * as React from 'react';
import Button from '@mui/material/Button';
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from "@mui/material/TextField";
import useDrive from "../../hooks/useDrive";
import useNotification from "../../hooks/useNotification";
import FileService from "../../services/FileService";
import AppUiDialogTitle from "../AppUiComponents/AppUiDialogTitle";
import DriveService from "../../services/DriveService";
import {DRIVE_TYPES} from "../../config/appConst";

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiPaper-root': {
        minWidth: "40vw"
    }
}));


export default function FileRenameDialog() {

    const {renameRow, changeRenameRow, CurrentDrive, changeCurrentDrive} = useDrive();
    const {addNotification} = useNotification();

    const handleClose = () => {
        changeRenameRow(null)
    };

    const handleSubmit = async event => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const name = data.get('fileName');
        const {parent} = CurrentDrive;
        if (name) {
            let params = {file_name: parent + "/" + renameRow.Key, file_name_new: parent + "/" + name};
            if ((parent !== "/" && parent === "") || !parent) {
                params = {file_name: renameRow.Key, file_name_new: name};
            }
            params["driveType"] = CurrentDrive.driveType;
            await FileService.rename(params);
            addNotification({
                type: "success",
                message: "File renamed successfully"
            });
            changeRenameRow(null);
            const drive = await DriveService.getFileTree(parent, CurrentDrive.driveType);
            if (CurrentDrive.driveType === DRIVE_TYPES.SHARED) {
                changeCurrentDrive({parent, drive: {}, sharedDrive: drive, driveType: CurrentDrive.driveType});
            } else {
                changeCurrentDrive({parent, drive});
            }
        }
    }
    return (
        <BootstrapDialog
            onClose={handleClose}
            open={!!renameRow}
            noValidate sx={{ mt: 1 }}
        >
            <form onSubmit={handleSubmit}>
                <AppUiDialogTitle id="file-exist-dialog-title" onClose={handleClose}>
                    Rename the Selected File
                </AppUiDialogTitle>
                <DialogContent dividers>
                    <TextField
                        name="fileName"
                        size={"small"}
                        margin="normal"
                        required
                        fullWidth
                        id="name"
                        label="File Name"
                        type="text"
                        defaultValue={renameRow && renameRow.Key ? renameRow.Key : ""}
                        autoFocus
                    />
                </DialogContent>
                <DialogActions>
                    <Button style={{backgroundColor: "#8c3b61"}} variant="contained" size="small" color={"info"} onClick={handleClose}>
                        cancel
                    </Button>
                    <Button style={{backgroundColor: "#8c3b61"}} variant="contained" size="small" color={"info"} autoFocus
                            type="submit"
                    >
                        save
                    </Button>
                </DialogActions>
            </form>

        </BootstrapDialog>
    );
}
